// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import VeeValidate from 'vee-validate'
import Paginate from 'vuejs-paginate'
import _ from 'lodash'
import moment from 'moment'
import accounting from 'accounting-js'
import jQuery from 'jquery'
import VueScrollactive from 'vue-scrollactive'
import Vue2Storage from 'vue2-storage'
import Treeselect from '@riophae/vue-treeselect'
import Helpers from './plugins/helpers'
import TheLoader from './components/TheLoader'
import TheEmptyList from './components/TheEmptyList'
import TheTextInput from './components/Inputs/TheTextInput'
import TheDateInput from './components/Inputs/TheDateInput'
import TheDecimalInput from './components/Inputs/TheDecimalInput'
import TheDecimalInputTable from './components/Inputs/TheDecimalInputTable'
import TheIntegerInput from './components/Inputs/TheIntegerInput'
import ThePhoneInput from './components/Inputs/ThePhoneInput'
import TheSelectInput from './components/Inputs/TheSelectInput'
import TheSwitchInput from './components/Inputs/TheSwitchInput'
import TheSwitchInputPopover from './components/Inputs/TheSwitchInputPopover'
import TheSwitchInputPopoverDragable from './components/Inputs/TheSwitchInputPopoverDragable'
import TheTextArea from './components/Inputs/TheTextArea'
import TheEmailInput from './components/Inputs/TheEmailInput'
import TheTextLineInput from './components/Inputs/TheTextLineInput'
import TheCountryInput from './components/Inputs/TheCountryInput'
import TheSwitchListSwitchInput from './components/Inputs/TheSwitchListSwitchInput'
import MultiSelectInput from './components/Inputs/MultiSelectInput'
import { VLazyImagePlugin } from 'v-lazy-image'
import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue'
import VueAnalytics from 'vue-analytics'
import Buefy from 'buefy'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import AvantiAccess from './plugins/access'

Object.defineProperty(Vue.prototype, 'Sentry', { value: Sentry })
Object.defineProperty(Vue.prototype, 'AvantiAccess', { value: AvantiAccess })

Vue.use(require('vue-shortkey'))
Vue.use(OverlayScrollbarsPlugin)
Vue.use(Buefy, {
  defaultContainerElement: '#app',
  defaultDayNames: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
  defaultMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
  //  ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
  defaultDateFormatter: (date) => {
    return moment(date).format('DD.MM.YYYY')
  },
  defaultDatepickerNearbySelectableMonthDays: true
})

// Add jQuery
window.$ = jQuery
window.jQuery = jQuery

Vue.config.productionTip = false

/**
 * Set token to the axios headers if we have one
 */
const token = localStorage.getItem('avanti-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.use(VLazyImagePlugin)

// Intitalize Sentry
Sentry.init({
  dsn: process.env.VUE_APP_AVANTI_SENTRY_DSN,
  environment: process.env.VUE_APP_AVANTI_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      // attachProps: true,
      logErrors: true
    })
  ]
})

// Google analytics
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-10548039-57',
    router
  })
}

/**
 * Add some global components
 */
Vue.component('TheLoader', TheLoader)
Vue.component('TheEmptyList', TheEmptyList)
Vue.component('TheTextInput', TheTextInput)
Vue.component('TheEmailInput', TheEmailInput)
Vue.component('TheDateInput', TheDateInput)
Vue.component('TheDecimalInput', TheDecimalInput)
Vue.component('TheDecimalInputTable', TheDecimalInputTable)
Vue.component('TheIntegerInput', TheIntegerInput)
Vue.component('ThePhoneInput', ThePhoneInput)
Vue.component('TheSelectInput', TheSelectInput)
Vue.component('TheSwitchInput', TheSwitchInput)
Vue.component('TheSwitchInputPopover', TheSwitchInputPopover)
Vue.component('TheSwitchInputPopoverDragable', TheSwitchInputPopoverDragable)
Vue.component('TheTextArea', TheTextArea)
Vue.component('TheTextLineInput', TheTextLineInput)
Vue.component('TheSwitchListSwitchInput', TheSwitchListSwitchInput)
Vue.component('TheCountryInput', TheCountryInput)
Vue.component('MultiSelectInput', MultiSelectInput)
Vue.component('paginate', Paginate)
Vue.component('Treeselect', Treeselect)

/**
 * Add lodash
 *
 * Use like this in your components:
 * this._.isEmpty(), this._.whatever()
 */
Object.defineProperty(Vue.prototype, '_', { value: _ })

/**
 * Add some global packages to Vue...
 */
Vue.use(Helpers)
Vue.use(VueScrollactive)

Vue.use(Vue2Storage, {
  prefix: 'bq_',
  driver: 'session', // memory, session, local
  ttl: 1000 * 60 * 2 // 2 minutes
})

const dict = {
  custom: {
    Auksjonskode: { required: 'Påkrevd' },
    from_email: { email: 'Må være en gyldig e-postadresse' },
    PaymentMethod: { required: 'Betalingsmetode er påkrevd' },
    Lev_dato: { required: 'Utlevert dato er påkrevd' },
    Konklusjon: { required: 'Rapportdetaljer er påkrevd' },
    Dato: { required: 'Dato er påkrevd' },
    Hvor: { required: 'Hvor er påkrevd' },
    Konsult: { required: 'Konsult er påkrevd' },
    Adresse: { required: 'Adresse er påkrevd' },
    Postnr: { required: 'Postnummer er påkrevd' },
    Poststed: { required: 'Poststed er påkrevd' },
    Telefon: { required: 'Telefon er påkrevd' },
    Utlopsdato: { required: 'Utløpsdato er påkrevd' },
    Auksjontype: { required: 'Auksjontype er påkrevd' },
    Legtype: { required: 'Legitimasjonstype er påkrevd', min_value: 'Legitimasjonstype er påkrevd' },
    Tittel: { required: 'Tittel er påkrevd', max: 'Tittel får ikke ha mer enn 50 tegn' },
    Fnavn: { required: 'Fornavn er påkrevd', max: 'Fornavn får ikke ha mer enn 50 tegn' },
    Enavn: { required: 'Etternavn er påkrevd', max: 'Etternavn får ikke ha mer enn 50 tegn' },
    Swift: { max: 'SWIFT får ikke ha mer enn 40 tegn' },
    Iban: { max: 'IBAN får ikke ha mer enn 40 tegn' },
    Betalings_info: { max: 'Betalingsinfo får ikke ha mer enn 255 tegn' },
    Kontonr: { required: 'Kontonummer er påkrevd', min: 'Kontonummeret må bestå av 11 siffer', max: 'Kontonummeret må bestå av 11 siffer' },
    Kontonummer: { required: 'Kontonummer er påkrevd', min: 'Kontonummeret må bestå av 11 siffer', max: 'Kontonummeret må bestå av 11 siffer' },
    PassordCurrent: { required: 'Nåværende passord er påkrevd' },
    Passord: { required: 'Nytt passord er påkrevd', min: 'Passord må ha minst 5 tegn' },
    PassordRepeat: { required: 'Nytt passord er påkrevd', confirmed: 'Passordene er ikke like' },
    Avdelingsid: { required: 'Avdeling er påkrevd' },
    Kontrakttype: { required: 'Fornavn er påkrevd' },
    Mottaker: { required: 'Etternavn er påkrevd' },
    Forsikring: { decimal: 'Forsikring må være et tall' },
    Forskudd: { decimal: 'Forskudd må være et tall' },
    Akonto: { decimal: 'A konto må være et tall' },
    Salar: { required: 'Salær er påkrevd', decimal: 'Salær må være et tall' },
    FirmaNavn: { required: 'Firmanavn er påkrevd' },
    Objekttype: { required: 'Kontrakttype er påkrevd' },
    Expertavdelingsid: { required: 'Ekspertavdeling er påkrevd' },
    Lokasjon: { required: 'Lokasjon er påkrevd' },
    Auksjon: { required: 'Auksjon er påkrevd' },
    Fotokostnad: { decimal: 'Fotokostnad må være et tall' },
    Kategori: { required: 'Kategori er påkrevd' },
    Kunstner: { required: 'Kunstner er påkrevd' },
    Katalogtekst1: { max: 'Får ikke ha mer enn 100 tegn' },
    Objekt3: { required: 'Beskrivelse/stilperiode er påkrevd', max: 'Beskrivelse/stilperiode får ikke ha mer enn 100 tegn' },
    Objekt1: { max: 'Signert får ikke ha mer enn 100 tegn' },
    Vurderingspris2: { required: 'Lav vurdering er påkrevd', decimal: 'Lav vurdering må være et tall' },
    Vurderingspris1: { required: 'Høy vurdering er påkrevd', decimal: 'Høy vurdering må være et tall' },
    Minstepris: { required: 'Minstepris er påkrevd', decimal: 'Minstepris må være et tall' },
    Rettelse: { max: 'Rettelse får ikke ha mer enn 500 tegn' },
    Hoyde: { decimal: 'Må være et tall' },
    Lengde: { decimal: 'Må være et tall' },
    Bredde: { decimal: 'Må være et tall' },
    Dybde: { decimal: 'Må være et tall' },
    Diameter: { decimal: 'Må være et tall' },
    Vekt: { decimal: 'Må være et tall' },
    Assuranseverdi: { decimal: 'Må være et tall' },
    Antatt_kvalitet: { decimal: 'Må være et tall' },
    Papirmal: { decimal: 'Må være et tall' },
    Lysmal: { decimal: 'Må være et tall' },
    email_from_name: { required: 'Påkrevd', max: 'Får ikke ha mer enn 100 tegn' },
    email_from_mail: { required: 'Påkrevd', email: 'Må være en gyldig e-postadresse' },
    email_to_name: { required: 'Påkrevd', max: 'Får ikke ha mer enn 100 tegn' },
    email_to_mail: { required: 'Påkrevd', email: 'Må være en gyldig e-postadresse' },
    email_subject: { required: 'Påkrevd', max: 'Får ikke ha mer enn 50 tegn' },
    email_content: { required: 'Påkrevd', max: 'Får ikke ha mer enn 500 tegn' },
    Rolle: { required: 'Rolle er påkrevd' },
    Brukernavn: { required: 'Brukernavn er påkrevd' },
    Email: { required: 'Email er påkrevd' },
    code: { required: 'Kode er påkrevd', max: 'Kode er for lang' },
    Kode: { required: 'Kode er påkrevd', max: 'Kode er for lang' },
    info: { required: 'Info er påkrevd', max: 'Teksten er for lang' },
    Betalingsartkode: { required: 'Betalingsartkode er påkrevd' },
    Bokforgruppekode: { required: 'Bokforgruppekode er påkrevd' },
    Navn: { required: 'Navn er påkrevd' },
    Kategorikode: { required: 'Kategorikode er påkrevd' },
    Tekst: { required: 'Tekst er påkrevd' },
    Lokasjonkode: { required: 'Lokasjonkode er påkrevd' },
    Mvakode: { required: 'Mvakode er påkrevd' },
    Mvapct: { required: 'Mvapct er påkrevd' },
    Navimvakode: { required: 'Navimvakode er påkrevd' },
    Beskrivelse: { required: 'Beskrivelse er påkrevd', max: 'Teksten er for lang' },
    Varekode: { required: 'Varekode er påkrevd' },
    Enhetskode: { required: 'Enhetskode er påkrevd' },
    Salgspris: { required: 'Salgspris er påkrevd', min_value: 'Salgspris må være høyere enn 1' },
    MottakerName: { required: 'Mottaker er påkrevd' },
    NettMerknad: { max: 'Får ikke ha mer enn 5000 tegn' },
    printerId: { required: 'Skriver er påkrevd' },
    labelType: { required: 'Etikett type er påkrevd' },
    labelCount: { required: 'Antall er påkrevd', min_value: 'Antall må være et tall mellom 1 og 25', max_value: 'Antall må være et tall mellom 1 og 25' },
    'adresseFaktura-Adresse': { required: 'Påkrevd' },
    'adresseFaktura-Postnr': { required: 'Påkrevd', max: 'Postnummer for langt' },
    'adresseFaktura-Poststed': { required: 'Påkrevd' },
    'adresseFaktura-Landkode': { required: 'Påkrevd' },
    'adresseLevering-Postnr': { required: 'Påkrevd', max: 'Postnummer for langt' },
    TypeOfSaleId: { required: 'Påkrevd' },
    Mobil: { required: 'Påkrevd' },
    Auksjon_dato: { required: 'Auksjon dato er påkrevd' },
    KatalogInfo: { required: 'Hvorfor katalog er påkrevd', max: 'Teksten er for lang' },
    Lokasjonid: { required: 'Lokasjon er påkrevd' },
    Spadenr: { required: 'Spadenr er påkrevd', min_value: 'Spadenr må være et tall mellom 1 og 9999', max_value: 'Spadenr må være et tall mellom 1 og 9999' },
    Kundenr: { required: 'Kunde er påkrevd' },
    Merknad: { required: 'Merknad er påkrevd' },
    Telefonopplysninger: { required: 'Telefonopplysninger er påkrevd' },
    Bud: { required: 'Forhåndsbud er påkrevd' },
    Starttid: { required: 'Starttid er påkrevd' },
    Sluttid: { required: 'Sluttid er påkrevd' },
    Sluttintervall: { required: 'Sluttintervall er påkrevd' },
    Sisteforhandsbud: { required: 'Siste frist for forhåndsbud er påkrevd' }
  }
}

VeeValidate.Validator.localize('en', dict)

Vue.use(VeeValidate, {
  events: 'blur|change',
  inject: false
})

/**
 * Create global input mixins
 *
 * Decimal, integer, avatar color
 */
Vue.mixin({
  data () {
    return {
      paginationArrow: '<svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg>',
      avantiEnv: process.env.VUE_APP_AVANTI_ENV
    }
  },
  methods: {
    hasAccess: function (minRole = 'others', exact = false) {
      return AvantiAccess.hasAccess(minRole, exact)
    },
    loadObjektModal: function (Objektid) {
      this.openModal(
        'kunde-kontrakt-objekt-modal',
        {
          loadObjektId: parseInt(Objektid)
        },
        'fullscreen'
      )
    },
    SentryDebug: function (message, context = null) {
      Sentry.captureMessage(message, scope => {
        scope.clear()

        if (this.$store.getters.getUser) {
          scope.setUser(
            {
              id: this.$store.getters.getUser.Brukerid,
              username: this.$store.getters.getUser.Brukernavn
            }
          )
        }

        if (context !== null) {
          scope.setContext('avantidata', { title: 'avantidata', data: JSON.stringify(context) })
        }

        return scope
      })
    },
    SentryException: function (exception, context = null) {
      Sentry.captureException(exception, scope => {
        scope.clear()

        if (this.$store.getters.getUser) {
          scope.setUser(
            {
              id: this.$store.getters.getUser.Brukerid,
              username: this.$store.getters.getUser.Brukernavn
            }
          )
        }

        if (context !== null) {
          scope.setContext('avantidata', { title: 'avantidata', data: JSON.stringify(context) })
        }

        return scope
      })
    },
    openConfirm: (theTitle, theText, okButtonText, cancelButtonText, okCallback, cancelCallback) => {
      store.dispatch('OPEN_MODAL', {
        modalName: 'TheConfirm',
        modalProps: {
          theTitle: theTitle,
          theText: theText,
          okButtonText: okButtonText,
          cancelButtonText: cancelButtonText,
          okCallback: okCallback,
          cancelCallback: cancelCallback
        },
        modalType: 'confirm',
        modalOnCloseEvent: null
      })

      window.jQuery('body').addClass('scroll-lock')
    },
    openModal: (modalName, modalProps, modalType, modalOnCloseEvent) => {
      store.dispatch('OPEN_MODAL', {
        modalName: modalName,
        modalProps: modalProps || null,
        modalType: modalType || null,
        modalOnCloseEvent: modalOnCloseEvent || null
      })

      window.jQuery('body').addClass('scroll-lock')
    },
    closeModal: () => {
      store.dispatch('HIDE_MODAL')

      window.jQuery('body').removeClass('scroll-lock')
    },
    updateModalProps: (propsPayload) => {
      store.dispatch('UPDATE_MODAL_PROP', propsPayload)
    },
    updateObjektModalProps: (propsPayload) => {
      store.dispatch('UPDATE_OBJEKT_MODAL_PROP', propsPayload)
    },
    setFormLoading: (mode) => {
      store.commit('SET_FORM_LOADING', !!mode)
    },
    setFormProcessing: (mode) => {
      store.commit('SET_FORM_PROCESSING', !!mode)
    },
    setFormDirty: (formName, mode) => {
      store.commit('SET_FORM_DIRTY', { name: formName, mode: !!mode })
    },
    isFormSubmittable: () => {
      return store.getters.isFormSubmittable
    },
    isFormDirty: (formName) => {
      return store.getters['isFormDirty'](formName)
    },
    kontraktStatusClass (status) {
      status = parseInt(status)

      switch (status) {
        case 0:
          // Draft (under utarbeidelse)
          return 'orange'
        case 1:
          // Pending (venter signatur)
          return 'lightblue'
        case 2:
          // Signed (singerat)
          return 'green'
        case 3:
          // Returned (returnert kontraktsansvarlig)
          return 'orange'
        case 4:
          // Void (annulert)
          return 'red'
        case 5:
          // Done (sålt, betalt...)
          return 'green'
        default:
          // Unknown
          return 'red'
      }
    },

    strToAvatarClass: function (str) {
      let clr = {
        'A': 'black',
        'B': 'orange',
        'C': 'red',
        'D': 'purple',
        'E': 'green',
        'F': 'yellow',
        'G': 'lightblue',
        'H': 'black',
        'I': 'orange',
        'J': 'red',
        'K': 'purple',
        'L': 'green',
        'M': 'yellow',
        'N': 'lightblue',
        'O': 'black',
        'P': 'orange',
        'Q': 'red',
        'R': 'purple',
        'S': 'green',
        'T': 'yellow',
        'U': 'lightblue',
        'V': 'black',
        'X': 'orange',
        'Y': 'red',
        'Z': 'purple',
        'Å': 'green',
        'Ä': 'yellow',
        'Æ': 'yellow',
        'Ö': 'lightblue',
        'Ø': 'lightblue',
        '-': 'pink' // Default, in case not found in array
      }

      let chr = this._.toUpper(this._.split(str, '', 1)[0])

      if (clr.hasOwnProperty(chr)) {
        return clr[chr]
      }

      return clr['-']
    },
    checkModulus11: function (input) {
      // Courtesy of https://www.npmjs.com/package/checkdigit

      if (!input) {
        return false
      }

      let checkDigitIndex = input.length - 1
      let checkValue = input.substr(checkDigitIndex)
      let createValue = input.substr(0, checkDigitIndex)

      let sum = 0
      createValue.split('').reverse().forEach(function (value, index) {
        sum += parseInt(value, 10) * (index % 6 + 2)
      })

      let sumMod11 = sum % 11

      if (sumMod11 === 0) {
        return checkValue === '0'
      } else if (sumMod11 === 1) {
        return checkValue === '-'
      }

      return checkValue === (11 - sumMod11) + ''
    }
  }
})

Vue.filter('nlbr', function (str, defaultReturn = '-') {
  if (!str) {
    return defaultReturn
  }

  return (str + '').replace(/(\r\n|\n\r|\r|\n)/g, '<br>' + '$1')
})

Vue.filter('truncate', function (value, length) {
  let options = {
    'length': length || 50,
    'separator': /,? +/
  }

  return _.truncate(value, options)
})

Vue.filter('toFixed', function (value, length) {
  if (value !== undefined && value !== null && value !== '') {
    return accounting.formatNumber(value, { precision: 2, thousand: ' ' })
  }

  return '0.00'
})

Vue.filter('thousands', function (value, length) {
  if (value !== undefined && value !== null && value !== '') {
    return accounting.formatNumber(value, { precision: 0, thousand: ' ' })
  }

  return '0'
})

Vue.filter('thousandsFloat', function (value, length = 2) {
  if (value !== undefined && value !== null && value !== '') {
    return accounting.formatNumber(value, { precision: length, thousand: ' ' })
  }

  return '0.00'
})

/**
 * Add filters for dates
 */
Vue.filter('norwegiandate', function (value) {
  if (!value) {
    return '-'
  }

  value = value.toString()

  const date = moment(value)

  return date.format('DD.MM.YYYY')
})

Vue.filter('avantidate', function (value) {
  if (!value) {
    return '-'
  }

  value = value.toString()

  let today = moment()
  let date = moment(value)

  if (date.isSame(today, 'day')) {
    return 'I dag'
  } else {
    return date.format('DD.MM.YYYY')
  }
})

Vue.filter('avantidatetime', function (value) {
  if (!value) {
    return '-'
  }

  value = value.toString()

  let today = moment()
  let date = moment(value)

  if (date.isSame(today, 'day')) {
    return 'I dag - ' + date.format('HH:mm')
  } else {
    return date.format('DD.MM.YYYY - HH:mm')
  }
})

Vue.filter('avantidatenice', function (value) {
  if (!value) {
    return '-'
  }

  value = value.toString()
  let today = moment()
  let date = moment(value)

  if (date.isSame(today, 'day')) {
    return 'I dag - ' + date.format('HH:mm')
  } else {
    return date.format('DD. MMM YYYY HH:mm')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js